function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Guide",
  transform: "translate(-155.000000, -829.000000)",
  fill: "#FF0000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M171.428712,839.053345 L164.268331,846.885348 C164.199896,846.960594 164.102641,847 164.001802,847 C163.900941,847 163.803707,846.960594 163.735272,846.885348 L156.574892,839.053345 C154.475036,836.760342 154.475036,833.030654 156.574892,830.737651 C157.59779,829.616232 158.962887,829 160.418006,829 C161.750677,829 163.011307,829.515925 164.001802,830.465354 C164.992297,829.515925 166.249322,829 167.581993,829 C169.037112,829 170.405792,829.616232 171.432318,830.737651 C173.524963,833.030654 173.521357,836.760342 171.428712,839.053345 Z",
  id: "Path"
})));

function SvgIconHeartFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartFilled);
export default __webpack_public_path__ + "static/media/icon-heart-filled.0797ba6c.svg";
export { ForwardRef as ReactComponent };